import { makeActionCreator } from '../../../utilities'
import { CrewConstants } from './crew.constants'

export const setShift = makeActionCreator(CrewConstants.SET_SHIFT, 'shift')
export const setShiftOptions = makeActionCreator(CrewConstants.SET_SHIFT_OPTIONS, 'shiftOptions')
export const setBase = makeActionCreator(CrewConstants.SET_BASE, 'base')
export const setBaseOptions = makeActionCreator(CrewConstants.SET_BASE_OPTIONS, 'baseOptions')
export const setStaffingLevel = makeActionCreator(CrewConstants.SET_STAFFING_LEVEL, 'staffingLevel')
export const setStaffingLevelOptions = makeActionCreator(
  CrewConstants.SET_STAFFING_LEVEL_OPTIONS,
  'staffingLevelOptions'
)
export const setVehicle = makeActionCreator(CrewConstants.SET_VEHICLE, 'vehicle')
export const setVehicleOptions = makeActionCreator(CrewConstants.SET_VEHICLE_OPTIONS, 'vehicleOptions')
export const setRegistrationTailNumber = makeActionCreator(
  CrewConstants.SET_REGISTRATION_TAIL_NUMBER,
  'registrationTailNumber'
)
export const setRegistrationTailOptions = makeActionCreator(
  CrewConstants.SET_REGISTRATION_TAIL_NUMBER_OPTIONS,
  'registrationTailOptions'
)
export const setUnitEquipment = makeActionCreator(CrewConstants.SET_UNIT_EQUIPMENT, 'unitEquipment')
export const setUnitEquipmentOptions = makeActionCreator(
  CrewConstants.SET_UNIT_EQUIPMENT_OPTIONS,
  'unitEquipmentOptions'
)
export const setPrimaryMonitor = makeActionCreator(CrewConstants.SET_PRIMARY_MONITOR, 'primaryMonitor')
export const setPrimaryMonitorOptions = makeActionCreator(
  CrewConstants.SET_PRIMARY_MONITOR_OPTIONS,
  'primaryMonitorOptions'
)

export const setName = makeActionCreator(CrewConstants.SET_NAME, 'userId', 'crewMember')
export const setCertificationLevel = makeActionCreator(
  CrewConstants.SET_CERTIFICATION_LEVEL,
  'certificationLevelId',
  'crewMember'
)
export const setRole = makeActionCreator(CrewConstants.SET_ROLE, 'roleId', 'crewMember')
export const setRolePNNV = makeActionCreator(CrewConstants.SET_ROLE_PNNV, 'roleIdPNNV', 'crewMember')
export const setPreceptorStudent = makeActionCreator(
  CrewConstants.SET_PRECEPTOR_STUDENT,
  'preceptorStudent',
  'crewMember'
)
export const setCrewRoleOptions = makeActionCreator(CrewConstants.SET_ROLE_OPTIONS, 'roleOptions')
export const setPreceptorStudentOptions = makeActionCreator(
  CrewConstants.SET_PRECEPTOR_STUDENT_OPTIONS,
  'preceptorStudentOptions'
)
export const onAddCrewMember = makeActionCreator(CrewConstants.ON_ADD_CREW_MEMBER)
export const setCrewList = makeActionCreator(CrewConstants.SET_CREW_LIST, 'crewList')
export const saveCrewListRequest = makeActionCreator(CrewConstants.SAVE_CREW_LIST_REQUEST, 'crewList')
export const setCrewListData = makeActionCreator(CrewConstants.SET_CREW_LIST_DATA, 'crewListData')
export const checkCrewList = makeActionCreator(CrewConstants.CHECK_CREW_LIST)
export const setPCRCrew = makeActionCreator(CrewConstants.SET_PCR_CREW, 'pcrCrew')
export const resetShiftStartup = makeActionCreator(CrewConstants.RESET_SHIFT_STARTUP)
export const setPersistShiftStartup = makeActionCreator(CrewConstants.SET_PERSIST_SHIFT_STARTUP)
export const getPersistShiftStartup = makeActionCreator(CrewConstants.GET_PERSIST_SHIFT_STARTUP)
export const setCrewLicensuresOptions = makeActionCreator(
  CrewConstants.SET_CREW_LICENSURES_OPTIONS,
  'crewLicensuresOptions'
)
